import RootState from "./rootState";

const state: RootState = {
  requestLoading: false,
  redirect: "",
};

export default state;
